import React from 'react'
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, FormHelperText } from '@material-ui/core';

export default function Select(props) {

    const { name, label, value,error=null, onChange, options } = props;

    return (
        <>
        {options &&
        <FormControl variant="outlined"
        {...(error && {error:true})}>
            <InputLabel>{label}</InputLabel>
            <MuiSelect sx={{ minWidth: '230px' }}
                label={label}
                name={name}
                value={value}
                onChange={onChange}>
                {
                    options.map(
                        (item, index) => (<MenuItem key={index} value={item}>{item}</MenuItem>)
                    )
                }
            </MuiSelect>
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
        }
        </>
    )
}
